import {configure, start, done} from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style

import router from "./router";
import {getToken} from "./utils/auth"; // get token from cookie
import getPageTitle from "./utils/get-page-title";
import {ElMessage, ElMessageBox} from "element-plus";
import {i18n, loadLanguageAsync} from "@/lang";
import {Storage} from "@/utils/storage";

configure({showSpinner: false}); // NProgress Configuration

const whiteList = ["/login", "/register", "/companyRegister", "/forgetPassword", "/guide", "/settingguide", '/cloud/download', '/cloud/info', '/google-oauth-demo', '/google-oauth-callback', '/microsoft-oauth-demo']; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
    const applyRouteTitle = () => {
        try {
            const matched = Array.isArray(to.matched) ? to.matched : []
            const recordWithTitle = [...matched].reverse().find(r => r?.meta?.title)
            const titleKey = recordWithTitle?.meta?.title || to.meta?.title
            if (titleKey) {
                setPageTitle(i18n.global.t(titleKey));
            }
        } catch (e) {
        }
    }

    const isWhatsAppLogin = () => {
        try {
            // 获取当前系统用户ID
            const userInfo = Storage.get('userInfo');
            const systemUserId = userInfo?.id || userInfo?.userId;
            const userId = systemUserId ? String(systemUserId) : '';
            
            // 优先读取账号特定的缓存
            let user = null;
            if (userId) {
                user = Storage.get(`wa_login_user_${userId}`);
            }
            // 如果没有账号特定缓存，再读取通用缓存（兼容旧数据）
            if (!user) {
                user = Storage.get('wa_login_user');
            }
            
            const isValid = !!(user && user.id && (user.name || user.pushName));
            console.log('[WhatsApp Guard] Checking:', { to: to.path, from: from.path, userId, user, isValid });
            return isValid;
        } catch (e) {
            console.log('[WhatsApp Guard] Error:', e);
            return false;
        }
    };

    // WhatsApp 路由守卫 - 必须在最前面，优先于全局 token 检查
    if (to.path.startsWith('/whatsapp/')) {
        console.log('[WhatsApp Guard] WhatsApp route detected:', to.path);

        // 进入 walogin 时先走一次中间加载页，避免先渲染登录页导致闪屏
        if (to.path === '/whatsapp/walogin' && !isWhatsAppLogin() && String(to.query?.skipLoading || '') !== '1') {
            next({
                path: '/whatsapp/waloading',
                query: {
                    ...(to.query || {}),
                    redirect: 'walogin'
                }
            });
            return;
        }
        
        if (to.path === '/whatsapp/walogin' && isWhatsAppLogin()) {
            console.log('[WhatsApp Guard] Already logged in, redirect to wahome');
            next('/whatsapp/wahome');
            return;
        }

        if (to.path === '/whatsapp/wahome' && !isWhatsAppLogin()) {
            console.log('[WhatsApp Guard] Not logged in, redirect to walogn');
            next({
                path: '/whatsapp/walogin',
                query: {
                    ...(to.query || {})
                }
            });
            return;
        }
        
        // 其他 whatsapp 路由直接放行
        console.log('[WhatsApp Guard] Allow WhatsApp route:', to.path);
        applyRouteTitle();
        next();
        return;
    }

    if ((from.path === "/email/customer/create" || from.path === "/email/write_mail") && to.path !== "/success" && to.path !== "/email/customer/list" && to.path !== "/email/examine") {
        if (to.path !== "/login" && to.path !== "/email/draft") {
            const confirmed = await confirmLeave();
            if (confirmed) {
                next();
            } else {
                next(false);
            }
        } else {
            next()
        }
    } else {
        // checkLoginTime();
        cancelAxiosRequests();
        startProgressBar();
        start();
        const hasToken = getToken();
        if (hasToken) {
            // 设置 page 页面 title
            applyRouteTitle();
            const forceLogin = String(to.query?.force || '') === '1'
            if (to.path === "/login" && !forceLogin) {
                next({path: "/"});
            } else {
                next();
            }
        } else {
            const isWhiteListed = whiteList.includes(to.path);
            const isDownloadPath = to.path.startsWith("/cloud/download/");
            const isDownloadInfo = to.path.startsWith("/cloud/info")
            if (isWhiteListed || isDownloadPath || isDownloadInfo) {
                console.log("未登录，放行", to.path);

                if (isDownloadPath) {
                    // 提取 key，例如 /cloud/download/abc123
                    const key = to.path.substring("/cloud/download/".length);
                    if (key) {
                        localStorage.setItem("key", key);
                    }
                }

                next();
            } else {
                console.log("未登录，跳转登录", to.path);
                next("/login");
            }
        }
    }

    // routerLoading ? glo_loading.loadingHide() : ''//关闭loading层

});

async function confirmLeave() {
    return ElMessageBox.confirm(i18n.global.t('system.permission.des'), i18n.global.t('sys.team.info'), {
        confirmButtonText: i18n.global.t('common.confirm'),
        cancelButtonText: i18n.global.t('common.cancel'),
        customClass: 'custom-confirm-box'
    })
        .then(() => true)
        .catch(() => false);
}

function cancelAxiosRequests() {
    if (Array.isArray(window.axiosCancelTokenList)) {
        window.axiosCancelTokenList.forEach((e) => e("cancel request"));
        window.axiosCancelTokenList = [];
    }
}

function startProgressBar() {
    // Your logic for starting progress bar
}

function setPageTitle(title) {
    document.title = getPageTitle(title);
}

router.afterEach((to, from, next) => {
    done();
});
